import { useMyEntitlements, useMyCbt } from "@/hooks/usePreparation";
import { useMyIntlEntitlements } from "@/hooks/useTransactions";
import { usePreferences } from "@/hooks/usePreferences";

/**
 * `is_premium` is an admin-only override (competition winners, scholarships,
 * partner schools, etc). It is NOT a product on the marketplace and is never
 * surfaced to students. When set, it unlocks every learning resource.
 */
function useAdminPremiumOverride() {
  const { data } = usePreferences();
  return !!data?.is_premium;
}

export function useHasFocusAccess(packageId?: string | null) {
  const { data: ents = [] } = useMyEntitlements();
  const premium = useAdminPremiumOverride();
  if (premium) return true;
  if (!packageId) return false;
  return ents.some((e) => e.package_id === packageId);
}

export function useHasIntlAccess(intlPackageId?: string | null) {
  const { data: ids = [] } = useMyIntlEntitlements();
  const premium = useAdminPremiumOverride();
  if (premium) return true;
  if (!intlPackageId) return false;
  return ids.includes(intlPackageId);
}

export function useHasCbt() {
  const { data: cbt } = useMyCbt();
  const premium = useAdminPremiumOverride();
  return premium || !!cbt;
}
